import React, { PureComponent, Fragment } from 'react'
import ModalDialog from '../common/ModalDialog'

import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'
import { onChangeEditHOF } from '../../utils/common'

import { apiGet, hasAccess } from '../../utils/api'
import { EditableTextField, EditableSwitch } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import { EditableSelect } from '../common/EditableComponents'
import { environmentOptions } from '../../utils/constants'

class StrongholdShopInfoItem extends PureComponent {
  onChange = onChangeEditHOF(this.props.onChange)

  enableEdit = () => {
    this.props.enableEdit()
  }

  onSave = () => {
    // const { isNotLinkedApiKey } = this.props;
    // if(!isNotLinkedApiKey) {
    //     this.confirmModal.handleClickOpen();
    //     return ;
    // }
    this.props.onChange('paymentOption', 'Stronghold', () =>
      this.props.onSave(() => this.props.disableEdit()),
    )
  }
  openDeleteShopModal = () => {
    this.shopDeleteModal.handleClickOpen()
  }
  onDelete = () => {
    const { data } = this.props
    this.props.onDelete(data.id)
    this.shopDeleteModal.handleClose()
  }

  render() {
    const { data = {}, editMode, isNotLinkedApiKey, shop = {} } = this.props

    return (
      <Fragment>
        <TableRow>
          <TableCell>{(shop && shop.name) || ''}</TableCell>
          <TableCell>
            <EditableTextField
              valueToRender={data.key}
              value={data.key}
              editMode={editMode}
              onChange={this.onChange('key')}
            />
          </TableCell>
          <TableCell>
            <EditableSelect
              valueToRender={data.environment}
              editMode={editMode}
              value={data.environment}
              onChange={this.onChange('environment')}
            >
              {environmentOptions.map((env) => {
                return <MenuItem value={env.value}>{env.label}</MenuItem>
              })}
            </EditableSelect>
          </TableCell>
          <TableCell>
            <EditableSwitch
              valueToRender={data.tipping ? 'Enabled' : 'Disabled'}
              checked={data.tipping}
              editMode={editMode}
              onChange={this.onChange('tipping', true)}
            />
          </TableCell>
          <TableCell>
            <EditableSwitch
              valueToRender={data.capturing ? 'Enabled' : 'Disabled'}
              checked={data.capturing}
              editMode={editMode}
              onChange={this.onChange('capturing', true)}
            />
          </TableCell>
          <TableCell>
            <EditableSwitch
              valueToRender={data.ignorePartnerPayLink ? 'Enabled' : 'Disabled'}
              checked={data.ignorePartnerPayLink}
              editMode={editMode}
              onChange={this.onChange('ignorePartnerPayLink', true)}
            />
          </TableCell>
          <TableCell>
            <EditableSwitch
              valueToRender={data.active ? 'Enabled' : 'Disabled'}
              checked={data.active}
              editMode={editMode}
              onChange={this.onChange('active', true)}
            />
          </TableCell>
          {hasAccess() ? (
            <TableCell>
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.props.onCancel}
                onEdit={this.enableEdit}
                editMode={editMode}
                editTitle={!isNotLinkedApiKey ? 'Update' : 'Link'}
              />
              {!editMode && data.id ? (
                <Button className="danger-button margin" onClick={this.openDeleteShopModal}>
                  Delete
                </Button>
              ) : null}
            </TableCell>
          ) : null}
        </TableRow>
        <ModalDialog
          title={'Delete Stronghold'}
          ref={(c) => (this.shopDeleteModal = c)}
          onConfirm={() => this.onDelete()}
          confirmText="Confirm"
        >
          <div> Are you sure you want to delete your Stronghold API Key? </div>
        </ModalDialog>
      </Fragment>
    )
  }
}

export default StrongholdShopInfoItem



// WEBPACK FOOTER //
// ./src/components/Stronghold/StrongholdShopInfoItem.js